export default {
  'primary': '#00284B',
  'secondary': '#00BFFF',
  'accent': '#00284B'
}
